import { PING_SERVICE_API_TOKEN } from "../util/constants";

export const fetchAccessToken = async (authCode) => {
  const apiEndpoint = process.env.REACT_APP_AUTH_API + PING_SERVICE_API_TOKEN;
  let requestParams = {
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      code: authCode,
    }),
  };
  const response = await fetch(apiEndpoint, requestParams);
  return response;
};

export const fetchPingSLO = async () => {
  return new Promise((resolve, reject) => {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = process.env.REACT_APP_PING_SLO_URL;
    iframe.onload = () => {
      document.body.removeChild(iframe);
      resolve();
    }
    iframe.onerror = () => {
      iframe.remove();
      reject(new Error("Failed to load iframe"));
    };

    document.body.appendChild(iframe);
  });
}